import Image from './image';
import Link from './link';
import Media from './media';
import RichtextModel from './richtext';

export class CtaBreaker {
  backgroundColor: string;
  backgroundImage: Media | null;
  description: RichtextModel | null;
  eyebrow: string;
  eyebrowColor: string;
  foregroundImage: Image | null;
  links: Link[];

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.backgroundImage = props.backgroundImage
      ? new Media(props.backgroundImage)
      : null;
    this.foregroundImage = props.foregroundImage
      ? new Image(props.foregroundImage)
      : null;
    this.description = props.description
      ? new RichtextModel(props.description)
      : null;
    this.eyebrow = props.eyebrow;
    this.eyebrowColor = props.eyebrowColor;
    this.links = props.linksCollection?.items.map((l: any) => new Link(l));
  }
}

export default CtaBreaker;
